<footer class="footer">
  <div class="row align-items-center justify-content-xl-between">
    <div class="col-xl-6">
      <div class="copyright text-center text-xl-left text-muted">
        &copy; {{ test | date: "yyyy" }} <a href="https://www.harry-hall.com?ref=ada-footer-admin-layout" class="font-weight-bold ml-1" target="_blank">Harry Hall</a>
      </div>
    </div>
    <div class="col-xl-6">
      <ul class="nav nav-footer justify-content-center justify-content-xl-end">
        <li class="nav-item">
          <a href="https://www.harry-hall.com?ref=ada-footer-admin-layout" class="nav-link" target="_blank">Harry Hall</a>
        </li>
        <li class="nav-item">
          <a href="https://www.harry-hall.com/presentation?ref=ada-footer-admin-layout" class="nav-link" target="_blank">About Us</a>
        </li>
        <li class="nav-item">
          <a href="http://blog.harry-hall.com?ref=ada-footer-admin-layout" class="nav-link" target="_blank">Blog</a>
        </li>
        <li class="nav-item">
          <a href="https://github.com/creativetimofficial/argon-dashboard-angular/blob/master/LICENSE.md" class="nav-link" target="_blank">MIT License</a>
        </li>
      </ul>
    </div>
  </div>
</footer>
